export const defaultTinyMCEOptions = {
  plugins: 'link autoresize',
  autoresize_min_height: 300,
  autoresize_max_height: 800,
  auto_focus: true,
  menubar: false,
  browser_spellcheck: true,
  toolbar:
    'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | indent outdent | link | removeformat',
  formats: {
    removeformat: [
      {
        selector: 'b,strong,em,i,font,u,strike',
        remove: 'all',
        split: true,
        expand: false,
        block_expand: true,
        deep: true,
      },
      { selector: 'h1,h2,h3,h4,h5,h6', remove: 'all', split: true, expand: false, block_expand: true, deep: true },
      { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
      { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true },
    ],
  },
  statusbar: false,
  skin_url: '/assets/tinymce/skins/lightgray',
}
